import React from "react";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { MdNavigateNext } from 'react-icons/md'
import { Link } from "react-router-dom";
import { AiFillCloseCircle } from 'react-icons/ai'
import { Box, Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import Paper from '@mui/material/Paper';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" to={'/price-breakup-list'} >
        <h4>Price  Breakup List</h4>
    </Link>,
    // <Link
    //     underline="hover"
    //     color="inherit"
    // >
    //     Prediction
    // </Link>
];
const listofprice = [
    {
        id: 1,
        startRank: 1,
        endRank: 10,
        eachPercentage: '10%',
    },
    {
        id: 2,
        startRank: 1,
        endRank: 5,
        eachPercentage: '20%',
    },
    {
        id: 3,
        startRank: 1,
        endRank: 1,
        eachPercentage: '100%',
    },
    {
        id: 4,
        startRank: 1,
        endRank: 2,
        eachPercentage: '50%',
    },
    {
        id: 5,
        startRank: 1,
        endRank: 4,
        eachPercentage: '25%',
    },
    {
        id: 6,
        startRank: 1,
        endRank: 100,
        eachPercentage: '1%',
    },
]
const PriceBreakUpList = () => {
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = (e) => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const addRow = () =>{

    }
    return (
        <>
            <div className="homeCard">
                <div className='subHomeCard'>
                    <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >

                        {breadcrumbs}
                    </Breadcrumbs>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <Button variant={'contained'} size={'small'} color={'success'} onClick={() => handleClickOpen('add')}>Add BreakUp</Button>
                        <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Id</TableCell>
                                        <TableCell align="center">Start Rank</TableCell>
                                        <TableCell align="center">End Rank</TableCell>
                                        <TableCell align="center">Each Percentage</TableCell>
                                        <TableCell align="center">Break Up</TableCell>
                                    </TableRow>
                                </TableHead>
                                {
                                    listofprice?.map((data, index) =>
                                        <TableBody>
                                            <TableRow
                                                key={data.name}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell align="center">{data.id}</TableCell>
                                                <TableCell align="center">{data.startRank}</TableCell>
                                                <TableCell align="center">{data.endRank}</TableCell>
                                                <TableCell align="center">{data.eachPercentage}</TableCell>
                                                <TableCell align="center">
                                                    <Button variant={'contained'} size={'small'} color={'success'} onClick={() => handleClickOpen(data)}>Edit BreakUp</Button>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )
                                }
                            </Table>
                        </TableContainer>
                    </Box>
                    <Dialog
                        fullScreen
                        open={open}
                        onClose={handleClose}
                        TransitionComponent={Transition}
                    >
                        <AppBar sx={{ position: 'relative' }} style={{ background: "black" }}>
                            <Toolbar>

                                <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                    Price Breakup Add
                                </Typography>
                                <Button style={{ marginRight: "20px" }} variant="contained" autoFocus color="success" onClick={handleClose}>
                                    save
                                </Button>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={handleClose}
                                    aria-label="close"
                                >
                                    <AiFillCloseCircle />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <Grid container>
                            <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Rank Id</TableCell>
                                            <TableCell align="center">Start Rank</TableCell>
                                            <TableCell align="center">End Rank</TableCell>
                                            <TableCell align="center">Each Percentage</TableCell>
                                            <TableCell align="center">Break Up</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell align="center">
                                                <TextField type="text" placeholder="Rank 1" />
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField type="text" placeholder="Start Rank" />
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField type="text" placeholder="Add" />
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField type="text" placeholder="Add" />
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField type="text" placeholder="Add" />
                                            </TableCell>
                                        </TableRow>
                                            <Button variant="outlined" color={'primary'} onClick={addRow}> Add</Button>
                                            <Button variant="outlined" color={'error'}>Remove</Button>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Dialog>
                </div>

            </div>
        </>
    )
}
export default PriceBreakUpList